import { radioCardSlotRecipe as base } from '@chakra-ui/react/theme';

import { formSelectionLabel, formSelectionSurface } from '../form-selection';
import { pressFeedback } from '../pressFeedback';

const baseVariants = base.variants as Record<string, Record<string, unknown>>;

export const radioCardSlotRecipe = {
  ...base,
  base: {
    ...base.base,
    item: {
      ...base.base?.item,
      ...pressFeedback,
      minH: '11',
      _disabled: { ...base.base?.item?._disabled, ...pressFeedback._disabled },
    },
  },
  variants: {
    ...base.variants,
    variant: {
      ...baseVariants.variant,
      pill: {
        item: {
          flex: '0',
          borderRadius: 'full',
          borderWidth: '1px',
          borderColor: 'transparent',
          bg: 'whiteAlpha.50',
          color: 'fg.secondary',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          transition: pressFeedback.transition,
          focusVisibleRing: 'outside',
          _hover: { bg: 'whiteAlpha.100', color: 'white' },
          _checked: {
            ...formSelectionSurface,
            _hover: {
              bg: 'bg.selectedHover',
            },
          },
        },
        itemControl: {
          px: 3,
          py: 1.5,
          gap: 1.5,
          alignItems: 'center',
        },
        itemIndicator: {
          display: 'none',
        },
        itemText: {
          ...formSelectionLabel,
        },
      },
    },
  },
};
